import firebaseLib from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import store from './store';

const FIREBASE_CONFIG = {
  apiKey: process.env.FIREBASE_API_KEY || 'AIzaSyDCmY4cjoNPpIpjSIQPRKHw8PKfMN8bL6U',
  authDomain: process.env.FIREBASE_DOMAIN || 'includecart.firebaseapp.com',
  projectId: process.env.FIREBASE_PROJECT_ID || 'includecart',
};

firebaseLib.initializeApp(FIREBASE_CONFIG);

// Initialize Cloud Firestore through Firebase
export const auth = firebaseLib.auth();
export const db = firebaseLib.firestore();

// Setup auth
auth.onAuthStateChanged(function(user) {
  if (user) {
    store.set('user', user);
  } else {
    store.set('user', null);
  }
});

/**
 * Query snapshot to array of results
 */
export function snapshotToArray(snapshot) {
  let results = [];

  if (snapshot.empty) {
    return results;
  }

  snapshot.forEach(function _formatEachDocFromSnapshot(doc) {
    results.push(formatDoc(doc));
  });

  return results;
}

/**
 * Format Firebase document object (adds 'id' to it)
 *
 * @param {object} doc
 * @return {object}
 */
export function formatDoc(doc) {
  return Object.assign({ id: doc.id }, doc.data());
}

/**
 * Remote/HTTP actions
 */
export const remote = {
  login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  },

  logout() {
    return auth.signOut();
  },

  register(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
  },
};
